// Logout.js

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { updateUser } from '../actions/user-actions';


class Logout extends Component {

  constructor(props) {
    super(props);
}

  onLogout(){
    console.log('Logging out');
    this.props.onUpdateUser('');
  }

  render() {
    this.onLogout();
    return (
      <div>
      <div>You have been logged out</div>
      <button className='btn btn-info' onClick={this.props.history.goBack}>Back</button>
      </div>
    );
  }
}


const mapStateToProps = state => ({
  products: state.products,
  user: state.user
});

const mapActionsToProps = {
  onUpdateUser: updateUser
};


export default connect(mapStateToProps, 
  mapActionsToProps
  )(Logout);


// WEBPACK FOOTER //
// ./src/components/Logout.js